import { createCustomEnum } from "./customEnum";

export type AchRecoverSourcesKeys =
	| "one_time_ach_debit_or_credit"
	| "on_reserve"
	| "jb_debit"
	| "residuals_withhold"
	| "residuals_adjustment"
	| "third_party_collections"
	| "not_applicable"
	| "other";

export const AchRecoverSources = createCustomEnum({
	OneTimeAchDebitOrCredit: {
		name: "one_time_ach_debit_or_credit",
		value: "one_time_ach_debit_or_credit",
		displayName: "One Time ACH Debit or Credit",
	},
	OnReserve: {
		name: "on_reserve",
		value: "on_reserve",
		displayName: "On Reserve",
	},
	JbDebit: { name: "jb_debit", value: "jb_debit", displayName: "JB Debit" },
	ResidualsWithhold: {
		name: "residuals_withhold",
		value: "residuals_withhold",
		displayName: "Residuals Withhold",
	},
	ResidualsAdjustment: {
		name: "residuals_adjustment",
		value: "residuals_adjustment",
		displayName: "Residuals Adjustment",
	},
	ThirdPartyCollections: {
		name: "third_party_collections",
		value: "third_party_collections",
		displayName: "Third Party Collections",
	},
	NotApplicable: {
		name: "not_applicable",
		value: "not_applicable",
		displayName: "Not Applicable",
	},
	Other: {
		name: "other",
		value: "other",
		displayName: "Other",
	},
});
